import React, { Component, Fragment, Children } from 'react'
import LogoInverse from '../../images/logo-engager-inverse.svg'
import Logo from '../../images/logo-engager.svg'
import { Link } from 'react-router-dom'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import LanguageSelector from '../../containers/language-selector'
import styled from 'styled-components'
import { formPagePath } from '../../utilities/route'
import ServerImage from '../server-image'
import UserSettingsWidget from '../../containers/user-settings-widget'
import { connect } from 'react-redux'
import { TABLET, LAPTOP, DESKTOP } from '../../utilities/breakpoints'

const mapStateToProps = (
  { survey: { surveyLanguages } }
) => {
  return {
    surveyLanguages,
  }
}

class NavBar extends Component {
  render() {
    const {
      renderClose,
      inverse = false,
      inverseDesktop = false,
      afterGame = false,
      logo,
      match: {
        params: { languageCode, surveyId },
      },
      children,
      middleChildren = false,
      to = false,
      surveyLanguages,
      canViewAfterGame = false,
      isAfterGameGuest = false
    } = this.props;

    const link = to || formPagePath(languageCode, surveyId);
    const isEmpty = !logo && Children.toArray(children).length < 1 && surveyLanguages.length < 2;

    return (
      <Fragment>
        {afterGame ?
          <NavMain className={`
          ${afterGame ? 'nav-aftergame' : 'nav-main'} 
          ${isEmpty ? 'is-empty' : ''} ${inverse ? 'inverse' : ''} 
          ${inverseDesktop ? 'inverseDesktop' : ''}`}>
            <NavLogoLink to={link}>
              {!inverseDesktop ?
                <img src={inverse ? LogoInverse : Logo} alt={'engager'}/>
                :
                <Fragment>
                  <img src={Logo} alt={'engager'} className="logo" />
                  <img src={LogoInverse} alt={'engager'} className="logo-inverse"/>
                </Fragment>
              }
            </NavLogoLink>
            <NavRight>
              {logo && logo.key && (
                <CustomerLogo className="customer-logo-container">
                  <ServerImage image={logo.key}>
                    {({ uri }) => (
                      <img className="nav-logo" src={uri} alt="" />
                    )}
                  </ServerImage>
                </CustomerLogo>
              )}
              {Children.toArray(children).length > 0 &&
                <NavLinks className={"ag-nav-links"}>
                  {children}
                </NavLinks>
              }
              {canViewAfterGame || isAfterGameGuest ?
                <div className="nav-right-widgets">
                  {surveyLanguages.length > 1 && <LanguageSelector />}
                  <UserSettingsWidget />
                </div>
                :
                surveyLanguages.length > 1 &&
                <div className="nav-right-widgets">
                  <LanguageSelector />
                </div>
              }
            </NavRight>
          </NavMain>
          :
          <NavMain className={`${afterGame ? 'nav-aftergame' : 'nav-main'} ${inverse ? 'inverse' : ''}`}>
            <NavLogoLink to={link}>
              <img src={inverse ? LogoInverse : Logo} alt={'engager'} />
            </NavLogoLink>
            {middleChildren && children}
            {renderClose ?
              null
              :
              <div className="nav-right-widgets">
                <LanguageSelector>{!middleChildren && children}</LanguageSelector>
              </div>
            }
          </NavMain>
        }
      </Fragment>
    );
  }
}

export default compose(withRouter, connect(mapStateToProps))(NavBar)

const NavMain = styled.nav`
  padding: 15px 20px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  min-height: 80px;
  
  .nav-right-widgets {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row-reverse;
    
    .nav-language + .user-settings {
      margin-right: 5px;
    }
  }
  
  &.nav-aftergame {
    position: relative;
    padding: 15px 0;
    flex-direction: column;
    align-items: flex-start;
    
    .nav-right-widgets {
      position: absolute;
      right: 0;
      top: 8px;
    }
  }
  
  .catalyst-progress {
    display: none;
  }
  
  .parameters-page & {
    padding-left: 0;
  }
  
  &.inverse .dropdown-language #toggle-dropdown-language,
  &.inverse .dropdown-language #toggle-dropdown-language .ant-select-arrow {
    color: #fff;
  }
  
  @media${TABLET} {
    padding: 30px 50px;
    min-height: 113px;
    
    &.nav-aftergame {
      padding: 30px 0;
      
      .nav-right-widgets {
        top: 20px;
      }
    }
  }
  
  @media${LAPTOP} {
    &.nav-aftergame {
      height: 120px;
      padding: 30px 0;
      flex-direction: row;
      align-items: center;
      
      .ag-nav-links + .nav-right-widgets {
        margin-left: 15px;
      }
      
      .nav-right-widgets {
        position: relative;
        top: 0;
        flex-direction: row;
        
        .nav-language + .user-settings {
          margin-right: 0;
          margin-left: 15px;
        }
        
        .nav-language.single-language + .user-settings {
          margin-left: 10px;
        }
      }
    }
    &.inverse .dropdown-language #toggle-dropdown-language,
    &.inverse .dropdown-language #toggle-dropdown-language .ant-select-arrow {
      color: initial;
    }
  }
  
  @media${DESKTOP} {
    padding: 30px 100px;
    
    &.nav-aftergame {
      padding: 30px 0;
    }
    
    .catalyst-progress {
      display: flex;
      max-width: 500px;
      margin-top: -17px;
    }
  }
`;

const NavLogoLink = styled(Link)`
  img {
    width: 145px;
    height: auto;
  }
  
  @media${LAPTOP} {

  }
`;

const CustomerLogo = styled.div`
  display: none;

  .nav-logo {
    height: 30px;
    max-width: 160px;
    object-fit: contain;
  }
  
  + .nav-language:not(.single-language) {
    margin-left: 10px;
  }
  + .ag-nav-links {
    margin-left: 20px;
  }  
  @media${LAPTOP} {
    display: flex;
  }
`;

const NavRight = styled.div`
  width: 100%;
  
  .is-empty & {
    display: none;
  }
    
  @media${LAPTOP} {
    display: flex;
    align-items: center;
    width: auto;
    background-color: #fff;
    border-radius: 10px;
    height: 60px;
    padding: 0 25px 0 25px;
  }
`;

const NavLinks = styled.ul`
  padding: 0;
  width: 100%;
  align-items: center;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  
  .nav-link {
    color: #23233f;
    font-weight: 500;
    padding: .5rem 0;

    &:hover,
    &:focus,
    &.active {
      color: #F58220;
    }
  }
  
  li:nth-child(1 of .nav-item) .nav-link {
    padding-left: 0;
  }
  
  .nav-item.active .nav-link {
    color: #F58220;

    &:hover,
    &:focus,
    &.active {
      color: #F58220;
    }
  }
  
  .nav-aftergame & {
    padding: 0;
    width: 100%;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 10px;
  }
  
  .inverse & {
    .nav-link {
      color: #fff;
    }
  }
  
  @media (min-width: 400px) {
    gap: 30px;
    .nav-aftergame & {
      .nav-link {
        padding: 0.5rem 0;
      }
    }
  }
  
  @media${LAPTOP} {
    .nav-aftergame & {
      width: auto;
      margin-top: 0;
    }
    
    .inverse & {
      .nav-link {
        color: #23233f;

        &:hover,
        &:focus,
        &.active {
          color: #F58220;
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/navigation/nav-bar.js